var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Pedestrians50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 12,
    r: 3,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.529,30.815l-0.081,0.557l-3.17,4.932c-0.522,0.813-0.287,1.896,0.526,2.418 C18.097,38.91,18.424,39,18.749,39c0.575,0,1.139-0.283,1.474-0.804l3.232-5.028C22.051,32.045,21.131,31.304,20.529,30.815z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.05,23.104l-3.807-1.5c0,0-3.379-3.614-3.381-3.615c-0.58-0.607-1.394-0.99-2.3-0.99 c-0.389,0-0.758,0.08-1.103,0.208c-0.006,0-5.458,1.877-5.458,1.877c-0.28,0.099-0.524,0.277-0.702,0.515l-3,4 c-0.497,0.663-0.363,1.604,0.3,2.101c0.27,0.202,0.585,0.3,0.899,0.3c0.456,0,0.906-0.207,1.201-0.6l2.727-3.637l1.314-0.435 c-0.292,1.815-0.696,4.324-0.704,4.376C20.013,25.871,20,26.04,20,26.213c0,0.854,0.306,1.635,0.814,2.241 c0.126,0.15,5.75,4.639,5.75,4.639l2.077,4.847c0.285,0.663,0.931,1.06,1.61,1.06c0.23,0,0.464-0.045,0.688-0.142 c0.888-0.381,1.3-1.409,0.919-2.298l-2.234-5.214c-0.054-0.135-0.126-0.265-0.217-0.388l0,0v-0.001 c-0.006-0.007-0.011-0.015-0.017-0.022l-3.408-4.465c0.228-1.378,0.491-2.97,0.691-4.184l1.602,1.608 c0.153,0.165,0.341,0.294,0.551,0.376l4.125,1.625C33.131,25.967,33.317,26,33.5,26c0.598,0,1.164-0.36,1.396-0.95 C35.199,24.279,34.821,23.408,34.05,23.104z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Pedestrians50);
export default __webpack_public_path__ + "static/media/icons8-pedestrians-50.142fdc260c866f45ded6217d1eed72e3.svg";
export { ForwardRef as ReactComponent };